
import { getLoginTime } from "../config/authsave";
import { handleSwalTokenExpired } from "../utils";

/**
 * @param {string} token
 * @param {string} loginTime
 * @returns {boolean} - true ถ้า Token หมดอายุแล้ว, false ถ้ายังไม่หมดอายุ
 */
const checkedTokenExpired = (token, loginTime) => {
  if (!token || !loginTime) {
    return true;
  }
  try {
    const payloadBase64 = token.split(".")[1];
    const decodedPayload = atob(payloadBase64);
    const payload = JSON.parse(decodedPayload);
    const expirationTimeInSeconds = payload.exp;
    const currentTimeInSeconds = Math.floor(Date.now() / 1000);

    let expired = currentTimeInSeconds >= expirationTimeInSeconds;
    const currentTime = Date.now();
    const timeElapsedInMinutes = (currentTime - loginTime) / (1000 * 60);
    const isExpiredByTime = timeElapsedInMinutes >= 90; // 90 minutes
    if (expired) {
      return true;
    }

    if (isExpiredByTime) {
      return true;
    }
    return false;
  } catch (error) {
    console.log("Failed to decode token:", error);
    return true;
  }
};

/**
 * ฟังก์ชันสำหรับเช็คว่า Token หมดอายุแล้วหรือไม่
 * @returns {boolean} - true ถ้า Token หมดอายุแล้ว, false ถ้ายังไม่หมดอายุ
 */
export const isTokenExpired = () => {
  const { loginTime, token } = getLoginTime() || {};
  const isExpiredByToken = checkedTokenExpired(token, loginTime);
  return isExpiredByToken;
};

/**
 * ฟังก์ชันนี้จะตรวจสอบสถานะของโทเค็นทุกๆ 1 นาที
 * @returns {number} - ID ของ Interval ที่ใช้ในการหยุดการทำงานในภายหลัง
 */
const handleTokenExpired = () => {
  if (sessionStorage.getItem("tokenExpiredAlertShow") === "true") {
    console.log(`Token Expired Alert Show : true`);
    return;
  }
  console.log(`Token Expired Alert Show : true`);
  sessionStorage.setItem("tokenExpiredAlertShow", "true");
  handleSwalTokenExpired(
    "Token expired.",
    "โทเค็นหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"
  );
};
export const startTokenCheckInterval = () => {
  // ตั้งค่า Interval ให้ทำงานทุกๆ 60 วินาที (1 นาที)
  const intervalId = setInterval(() => {
    const isExpired = isTokenExpired();
    if (isExpired) {
       handleTokenExpired();
      console.log("Token expired. Stopping interval.");
      clearInterval(intervalId);
    }
  }, 60 * 1000); // 60,000 มิลลิวินาที = 1 นาที
  console.log("Token check interval started.");
  return intervalId;
};
